/**
 * Связанные доки:
 * - docs/living/okdoc/OKDOC_SCENARIOS_FOUNDATION.md
 * - docs/living/taxonomy/TEMPLATE_OKDOC_TAXONOMY_ARCHITECTURE.md
 * Если меняется taxonomy OKDoc сценариев, обновляйте и код, и доки.
 */
import type { OkdocScenarioFamily, OkdocScenarioKind, OkdocSourceContext } from '@/features/okdoc/types';

export const OKDOC_SCENARIO_FAMILY_LABELS: Record<OkdocScenarioFamily, string> = {
  notification: 'Уведомительные',
  service_followup: 'После приёма',
  marketing: 'Маркетинг',
  feedback: 'Обратная связь',
  account: 'Личный кабинет',
  retention: 'Удержание',
  reactivation: 'Реактивация',
};

export const OKDOC_SCENARIO_KIND_LABELS: Record<OkdocScenarioKind, string> = {
  appointment_confirmation: 'Подтверждение записи',
  appointment_info: 'Подробности записи',
  feedback_collection: 'Сбор ОС',
  external_redirect: 'Внешний переход',
  recommendations: 'Рекомендации',
  promo_offer: 'Акция / оффер',
  personal_account: 'Личный кабинет',
  contact_hub: 'Каналы связи и ЛК',
  birthday_offer: 'День рождения / подарок',
};

export const OKDOC_SOURCE_CONTEXT_LABELS: Record<OkdocSourceContext, string> = {
  event_driven: 'Event-Driven',
  manual_broadcast: 'Ручная рассылка',
  scheduled_campaign: 'Кампания / расписание',
};

export const OKDOC_SCENARIO_FAMILY_OPTIONS = Object.entries(OKDOC_SCENARIO_FAMILY_LABELS).map(([value, label]) => ({ value, label }));
export const OKDOC_SCENARIO_KIND_OPTIONS = Object.entries(OKDOC_SCENARIO_KIND_LABELS).map(([value, label]) => ({ value, label }));
export const OKDOC_SOURCE_CONTEXT_OPTIONS = Object.entries(OKDOC_SOURCE_CONTEXT_LABELS).map(([value, label]) => ({ value, label }));

export function getOkdocScenarioFamilyLabel(value?: string): string {
  if (!value) return '';
  return OKDOC_SCENARIO_FAMILY_LABELS[value as OkdocScenarioFamily] || value;
}

export function getOkdocScenarioKindLabel(value?: string): string {
  if (!value) return '';
  return OKDOC_SCENARIO_KIND_LABELS[value as OkdocScenarioKind] || value;
}

export function getOkdocSourceContextLabel(value?: string): string {
  if (!value) return '';
  return OKDOC_SOURCE_CONTEXT_LABELS[value as OkdocSourceContext] || value;
}
